
class Colors {
    static primary = '#258E01';
}

export default Colors;